import { NON_PRIME_FILTERS } from '~/config/blog';
import { useRouter } from 'next/router';
import Link from 'next/link';
import LinkBar from '@referralexchange/rea-ui-react/src/components/navigation/LinkBar';

export default function BlogBar({ blog_hide_tags }) {
  const router = useRouter();
  const menu = [
    {
      label: 'Latest',
      href: '/blog',
    },
    {
      label: 'Agent',
      href: '/blog/agent',
    },
    {
      label: 'Buying',
      href: '/blog/buying',
    },
    {
      label: 'Mortgage',
      href: '/blog/mortgage',
    },
    {
      label: 'PRIME',
      href: '/blog/prime',
    },
    {
      label: 'Process',
      href: '/blog/process',
    },
    {
      label: 'Selling',
      href: '/blog/selling',
    },
  ];

  const filteredMenu = () => {
    if (blog_hide_tags) {
      return menu.filter(
        (item) =>
          !NON_PRIME_FILTERS.exclude.tags.includes(item.label.toLowerCase())
      );
    } else {
      return menu;
    }
  };

  const active = filteredMenu().findIndex((item) => {
    if (item.href === '/blog') {
      return (
        router.asPath === item.href || router.asPath.includes('/blog/page')
      );
    } else {
      return router.asPath.includes(item.href);
    }
  });

  const LinkElm = (item) => (
    <Link href={item.href} key={item.href}>
      {item.label}
    </Link>
  );

  const items = filteredMenu().map((item) => LinkElm(item));

  return <LinkBar items={items} active={active} sticky />;
}
